import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AuthService, scrollToTop} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-fab-shortcut',
    templateUrl: './fab-shortcut.component.html',
    standalone: false
})
export class FabShortcutComponent implements OnInit {

    @ViewChild('backToTop') backToTop!: ElementRef;
    authenticated!: boolean;

    constructor(
        private authService: AuthService,
        private renderer: Renderer2) {
    }

    ngOnInit(): void {
        this.authenticated = this.authService.isAuthenticated();
    }

    scrollTop($event: MouseEvent) {
        $event.preventDefault();
        scrollToTop(400);
    }

    logout($event: MouseEvent) {
        $event.preventDefault();
        this.authService.logout();
    }

    @HostListener('window:scroll') onScroll() {
        const offset = 200;
        const currentPosition = window.pageYOffset;
        if (currentPosition > offset) {
            if (!this.backToTop.nativeElement.classList.contains('is-active')) {
                this.renderer.addClass(this.backToTop.nativeElement, 'is-active');
            }
        } else {
            this.renderer.removeClass(this.backToTop.nativeElement, 'is-active');
        }
    }

}
